import { parseEmailList } from "@/lib/email/utils/parse-recipients";
import { HotelChainRep } from "@/lib/types/hotel";

export interface ChainRepFallbackRecipients {
  to: string[];
  cc: string[];
}

/**
 * Splits chain reps into a `TO` fallback and a `CC` remainder, for use when a
 * venue has no email of its own. Prefers reps flagged `direct_recipient`; if
 * none are flagged, every rep with an email becomes `TO` so the venue is never
 * silently skipped. Reps chosen for `TO` never also appear in `cc`.
 *
 * @param chainReps - The chain reps resolved for the venue's chain.
 * @returns Deduped, validated `to` and `cc` address lists (both may be empty).
 */
export function selectChainRepFallbackRecipients(chainReps: HotelChainRep[]): ChainRepFallbackRecipients {
  const directReps = chainReps.filter((rep) => rep.direct_recipient && rep.email);
  const toReps = directReps.length > 0 ? directReps : chainReps.filter((rep) => rep.email);

  const to = parseEmailList(toReps.map((rep) => rep.email).join(","));
  const toLookup = new Set(to.map((email) => email.toLowerCase()));
  const cc = parseEmailList(chainReps.map((rep) => rep.email).join(",")).filter(
    (email) => !toLookup.has(email.toLowerCase())
  );

  return { to, cc };
}
